import React from 'react';
// import {Field, Form} from "react-final-form";
import {Field} from "react-final-form";
/*** required for SELECT field onChange event capture or value chance capture in calculations --- START */
import { OnChange } from 'react-final-form-listeners';
/*** required for SELECT field onChange event capture or value chance capture in calculations --- END */
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  // InputLabel,
  MenuItem,
  RadioGroup,
  TextField,
  // Typography,
                                                                                      // Radio,
} from '@material-ui/core';
import {
  Checkbox,
  Radio,
  Select,
  // SelectField,
  // TextField,
                                                                                      // Radio,
} from 'final-form-material-ui';
import Toggle from 'material-ui/Toggle'
import SnackbarError from 'components/snackbar/snackbar-error';


export const renderLockedTextField = ({
  requiredText,
  label,
  id,
  emptyText,
  footerMessage,
  setValue,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <div>
    <TextField
      required={false}
      disabled={true}
      label={label}
      placeholder={emptyText}
      helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
      error={error ? true : false}
      hinttext={footerMessage}
      value={setValue}
      fullWidth
      variant="outlined"
      {...custom}
    />
  </div>
);


export const renderTextField = ({
  requiredText,
  locked,
  label,
  id,
  emptyText,
  footerMessage,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <div>
    <TextField
      required={requiredText ? true : false}
      disabled={locked}
      label={label}
      placeholder={emptyText}
      helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
      error={error ? true : false}
      hinttext={footerMessage}
      fullWidth
      variant="outlined"
      {...input}
      {...custom}
    />
  </div>
);





// prior
export const renderTextField2 = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  input,
  meta: { touched, invalid, error },
 ...custom
                          // objName,                        
                                                                    // input,
                                                            // ...rest
}) => (
<FormControl fullWidth error={touched }>
 <TextField
    required={requiredText ? true : false }
    disabled={locked}
    label={label}
    placeholder={emptyText}
    helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                                                                                        // error={touched && invalid}
    error={error ? true : false}
                                                                                        // hintText={footerMessage}
    hinttext={footerMessage}
    fullWidth
    variant='outlined'
    {...input}
    {...custom}
                // type="email"
                // component={TextField}
                // name={objName}
                // defaultValue={defaultValue}
                // value={value}
                                                                // error={touched && invalid} // remove                 
 />
 <FormHelperText>
 {(error) ? <span><b> <br /> {error} </b></span>: ''}
                                                                                      {/* {footerMessage} */}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                                      {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                                      {/* {(error) ? <> <br /> {error} </>: ''} */}
 </FormHelperText>
</FormControl>
)


                                                        // /*** Textboxes works */
                                                        // export const renderTextField2 = ({
                                                        //   objName,
                                                        //   requiredText,
                                                        //   locked,
                                                        //   label,
                                                        //   emptyText,
                                                        //   footerMessage,
                                                        //   defaultValue,
                                                        //   value,
                                                        //   meta: { touched, invalid, error },
                                                        //                                               // input,
                                                        //                                               // ...rest
                                                        // }) => (
                                                        // <FormControl fullWidth error={touched }>
                                                        //   <Field
                                                        //     type="text"
                                                        //     component={TextField}
                                                        //     required={requiredText ? true : false }
                                                        //     disabled={locked}
                                                        //     name={objName}
                                                        //     label={label}
                                                        //     placeholder={emptyText}
                                                        //     helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                                                        //     defaultValue={defaultValue}
                                                        //     value={value}
                                                        //                                                     // error={touched && invalid} // remove 
                                                        //     error={error ? true : false}
                                                        //     hinttext={footerMessage}                                      
                                                        //     fullWidth
                                                        //     variant='outlined'
                                                        //                                                     // {...input}
                                                        //                                                     // {...rest}
                                                        //   />
                                                        //   <FormHelperText>
                                                        //     {(error) ? <span> <b> {footerMessage} </b></span>: ''}
                                                        //                                 {/* same as helperText but this will be bold UN like helperText above */}
                                                        //                                 {/* {"FormHelperText - " + footerMessage} */}
                                                        //                                 {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
                                                        //                                 {/* {(error) ? <span> {"FormHelperText - " + footerMessage} <b> <br /> {error} </b></span>: ''} */}
                                                        //                                                                 {/* {footerMessage} */}
                                                        //                                                                 {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                        //                                                                 {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                        //                                                                 {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                        //   </FormHelperText>
                                                        // </FormControl>
                                                        // )

/*** EMAIL Textboxes works */
export const renderTextField_EMAIL = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  input,
  meta: { touched, invalid, error },
 ...custom
                        // objName,                        
                                                                    // input,
                                                            // ...rest
}) => (
<FormControl fullWidth error={touched }>
  <TextField
     type="email"
    required={requiredText ? true : false }
    disabled={locked}
    label={label}
    placeholder={emptyText}
    helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                                                                                        // error={touched && invalid}
    error={error ? true : false}
                                                                                        // hintText={footerMessage}
    hinttext={footerMessage}
    fullWidth
    variant='outlined'
    {...input}
    {...custom}
                // type="email"
                // component={TextField}
                // name={objName}
                // defaultValue={defaultValue}
                // value={value}
                                                                // error={touched && invalid} // remove                 
  />
  <FormHelperText>
    {(error) ? <span> <b> {footerMessage} </b></span>: ''}
                                {/* same as helperText but this will be bold UN like helperText above */}
                                {/* {"FormHelperText - " + footerMessage} */}
                                {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
                                {/* {(error) ? <span> {"FormHelperText - " + footerMessage} <b> <br /> {error} </b></span>: ''} */}
                                                                {/* {footerMessage} */}
                                                                {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                {/* {(error) ? <> <br /> {error} </>: ''} */}
  </FormHelperText>
</FormControl>
)

/*** PASSWORD Textboxes works */
export const renderTextField_PASSWORD = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  input,
  meta: { touched, invalid, error },
 ...custom
                        // objName,                        
                                                                    // input,
                                                            // ...rest
}) => (
  <FormControl fullWidth error={touched }>
 <TextField
    type="password"

    required={requiredText ? true : false }
    disabled={locked}
    label={label}
    placeholder={emptyText}
    helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                                                                                        // error={touched && invalid}
    error={error ? true : false}
                                                                                        // hintText={footerMessage}
    hinttext={footerMessage}
    fullWidth
    variant='outlined'
    {...input}
    {...custom}
                // type="email"
                // component={TextField}
                // name={objName}
                // defaultValue={defaultValue}
                // value={value}
                                                                // error={touched && invalid} // remove                                                      
    />
    <FormHelperText>
      {(error) ? <span> <b> {footerMessage} </b></span>: ''}
                                  {/* same as helperText but this will be bold UN like helperText above */}
                                  {/* {"FormHelperText - " + footerMessage} */}
                                  {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
                                  {/* {(error) ? <span> {"FormHelperText - " + footerMessage} <b> <br /> {error} </b></span>: ''} */}
                                                                  {/* {footerMessage} */}
                                                                  {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                  {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                  {/* {(error) ? <> <br /> {error} </>: ''} */}
    </FormHelperText>
</FormControl>
)






/*** DATE Textboxes works */
export const renderTextField_DATE = ({
  requiredText,
  locked,
  label,
  defaultValue,
  emptyText,
  footerMessage,
  rows,
  input,
  input: { value },
  meta: { touched, invalid, error },
  ...custom
}) => (
  <FormControl fullWidth error={touched}>
    <TextField
      type="date"
      InputLabelProps={{
        shrink: true
      }}
      label={label}
      defaultValue={defaultValue}
      disabled={locked}
      value={value}
      {...input}
      {...custom}
    />

    <FormHelperText>
      {error ? (
        <span>
          {' '}
          <b> {footerMessage} </b>
        </span>
      ) : (
        ''
      )}
    </FormHelperText>
  </FormControl>
);




  /*** DATE Textboxes works */
  export const renderTextField_DATE2 = ({
    requiredText,
    locked,
    label,
    defaultValue,
    emptyText,
    footerMessage,
    rows,
    input,
    // onChange,
    input: { value },
    // input: { onChange, value },
    // input: { onChange },

    // meta: { onChange, touched, invalid, error },
    meta: {  touched, invalid, error },
   ...custom

              // objName,
              // defaultValue,
              // value,
              // meta: { touched, invalid, error },
                                                // input,
                                                // ...rest
  }) => (
  <FormControl fullWidth error={touched }>
    {/* <Typography>{label}</Typography> */}
    {/* <Field */}






    
                                                        
                                                        
                                                        {/* defaultValue="2017-05-24" */}
                                                        {/* InputLabelProps={{
                                                          shrink: true,
                                                        }} */}
                                                      {/* /> */}







      <TextField
        type="date"
        InputLabelProps={{
          shrink: true,
        }}
        label={label}
        defaultValue={defaultValue}
                                                        // className={classes.textField}
        disabled={locked}

                                                        
        // onChange={onChange}

        value={value}
              {...input}
              {...custom}
      // {...input}
      // {...custom}
    
      />








{/*       







    <TextField
       type="date"
       //  defaultValue="2010-01-01"
      required={requiredText ? true : false }
      disabled={locked}
      

      id={name}


      label={label}
      placeholder={emptyText}
            // hintText={footerMessage}

            // error={touched && invalid}
      error={error ? true : false}
      helperText={touched && error}
      // helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
      
      onChange={onChange}
      fullWidth
      variant='outlined'
      // {...input}
      // {...custom}





      // component={TextField}
      
      
      // name={objName}
                                                // label={label} // blocks the view

      // defaultValue={defaultValue}
      // value={value}
                                                      // error={touched && invalid} // remove 
      
                                            
      
      
    /> 
    */}






    <FormHelperText>
      {(error) ? <span> <b> {footerMessage} </b></span>: ''}
                                  {/* same as helperText but this will be bold UN like helperText above */}
                                  {/* {"FormHelperText - " + footerMessage} */}
                                  {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
                                  {/* {(error) ? <span> {"FormHelperText - " + footerMessage} <b> <br /> {error} </b></span>: ''} */}
                                                                  {/* {footerMessage} */}
                                                                  {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                  {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                  {/* {(error) ? <> <br /> {error} </>: ''} */}
    </FormHelperText>
  </FormControl>
)

                  /*** TIME Textboxes works */
                  export const renderTextField_TIME = ({
                    requiredText,
                    locked,
                    label,
                    emptyText,
                    footerMessage,
                    rows,
                    input,
                    meta: { touched, invalid, error },
                  ...custom

                              // objName,
                              // defaultValue,
                              // value,
                              // meta: { touched, invalid, error },
                                                                // input,
                                                                // ...rest
                  }) => (
                  <FormControl fullWidth error={touched }>
                  {/* <Typography>{label}</Typography> */}
                  {/* <Field */}
                  <TextField
                    type="time"
                    //  defaultValue="2010-01-01"
                    required={requiredText ? true : false }
                    disabled={locked}
                    label={label}
                    placeholder={emptyText}
                          // hintText={footerMessage}

                          // error={touched && invalid}
                    error={error ? true : false}
                    helperText={touched && error}
                    // helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                    
                    fullWidth
                    variant='outlined'
                    {...input}
                    {...custom}





                    // component={TextField}
                    
                    
                    // name={objName}
                                                              // label={label} // blocks the view

                    // defaultValue={defaultValue}
                    // value={value}
                                                                    // error={touched && invalid} // remove 
                    
                                                          
                    
                                        />
                    <FormHelperText>
                      {(error) ? <span> <b> {footerMessage} </b></span>: ''}
                                                  {/* same as helperText but this will be bold UN like helperText above */}
                                                  {/* {"FormHelperText - " + footerMessage} */}
                                                  {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
                                                  {/* {(error) ? <span> {"FormHelperText - " + footerMessage} <b> <br /> {error} </b></span>: ''} */}
                                                                                  {/* {footerMessage} */}
                                                                                  {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                                  {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                                  {/* {(error) ? <> <br /> {error} </>: ''} */}
                    </FormHelperText>
                  </FormControl>
                  )




/*** Multi Line Textbox */
export const renderTextField_MULTILINE = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  defaultValue,
  value,
  rows,
  meta: { touched, invalid, error },
  input,
  ...custom
}) => (
  <FormControl fullWidth error={touched}>
    <TextField
      required={requiredText ? true : false}
      disabled={locked}
      label={label}
      placeholder={emptyText}
      helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
      multiline
      rows={rows}
      error={error ? true : false}
      hinttext={footerMessage}
      fullWidth
      variant="outlined"
      {...input}
      {...custom}
    />
    <FormHelperText>
      {error ? (
        <span>
          {' '}
          <b> {footerMessage} </b>
        </span>
      ) : (
        ''
      )}
    </FormHelperText>
  </FormControl>
);


// prior
/*** Multi Line Textbox */
export const renderTextField_MULTILINE2 = ({
                                              // objName,
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  defaultValue,
  value,
  rows,
  meta: { touched, invalid, error },
  input,
  ...custom
}) => (
<FormControl fullWidth error={touched }>
<TextField
    required={requiredText ? true : false }
    disabled={locked}
    label={label}
    placeholder={emptyText}
    helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
    multiline
    rows={rows}

                                                                                        // error={touched && invalid}
    error={error ? true : false}
                                                                                        // hintText={footerMessage}
    hinttext={footerMessage}
    fullWidth
    variant='outlined'
    {...input}
    {...custom}
                // type="email"
                // component={TextField}
                // name={objName}
                // defaultValue={defaultValue}
                // value={value}
                                                                // error={touched && invalid} // remove                 

                                                    // error={touched && invalid} // remove
  />
  <FormHelperText>
    {(error) ? <span> <b> {footerMessage} </b></span>: ''}
    {/* {footerMessage} */}
    {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}

                                {/* same as helperText but this will be bold UN like helperText above */}
                                {/* {"FormHelperText - " + footerMessage} */}
                                {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
                                {/* {(error) ? <span> {"FormHelperText - " + footerMessage} <b> <br /> {error} </b></span>: ''} */}
                                                                {/* {footerMessage} */}
                                                                {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                {/* {(error) ? <> <br /> {error} </>: ''} */}
  </FormHelperText>
</FormControl>
)

/*** checkbox WORKS */
export const renderCheckbox = ({
  objName,
  label,
  locked,
  footerMessage,
  input: { checked },
  meta: { touched, invalid, error },
  ...custom              
              // checked,
                                                      // ...rest
}) => (
<FormControl 
  fullWidth 
  error={touched}
>




                          {/* 
                          <Field
                            component={Checkbox}

                        checked={checked} 

                          // onChange={onChange}

                            name={objName}
                            label={label}
                            disabled={locked ? true : false }
                            {...custom}
                          /> 
                          */}




                                                <FormControlLabel
                                                  label={label}
                                                  control={
                                                    <Field
                                                      type="checkbox"
                                                      component={Checkbox}
                                                      checked={checked}
                                                      name={objName}
                                                      label={label}
                                                      disabled={locked ? true : false } 
                                                      // onChange={onChange}
                                                                                            // {...rest}
                                                    /> 
                                                  }
                                                />
                                                


    <FormHelperText>
      {footerMessage}
      {(error) ? <span><b> <br /> {error} </b></span>: ''}
    </FormHelperText>
  </FormControl>
)

/*** Toggle Switch aka Checkbox */
export const renderToggle = ({ 
  label,
  locked,
  checked,
  footerMessage,
  input: { onChange, value },
  meta: { touched, invalid, error },
  ...rest
}) => (
  <FormControl fullWidth error={touched }>
      <Toggle
        disabled={locked}
        label={label}
        toggled={!!value}
        onToggle={(event, isInputChecked) => onChange(isInputChecked)}
        {...rest}
      />
    <FormHelperText>
      {footerMessage}
      {(error) ? <span><b> <br /> {error} </b></span>: ''}
                                                            {/* {(touched && error) ? '<br />' + touched && error : ''} */}
    </FormHelperText>
  </FormControl>
)

/*** Radio Group */
/*** NOTE REQUIRES objName to set the name !!! */
/*** dataArray = [ { value: 1, label: 'label' }] */
export const renderRadioGroupField = ({
          footerMessage,
          id,
          input,
          label,
          locked,
          // meta: { touched, error },
          children,

          dataArray,
          meta: { onChange, touched, invalid, error },
        
                                                                                              // ...rest,
          ...custom

  // objName,
                                        // requiredText,
  
  
                                        // emptyText,
  
                                        // defaultValue,
  // value,
                                        // input,
                                        // ...rest
}) => (
  <FormControl component="fieldset">
    <FormLabel component="legend">
      {label}
    </FormLabel>

    <RadioGroup 
      // aria-label="gender" 
      // name="gender1" 
      // value={value} 
      // onChange={onChange}

      {...input}
      {...custom}

      disabled={locked}

      native

    >
      {dataArray.map((optionItem) => (
        <React.Fragment key={optionItem.value} >
          <FormControlLabel
            control={<Radio />} 
            value={optionItem.value}
            label={optionItem.label}
          />
        </React.Fragment>
      ))}
                                            {/* 
                                                          <FormControlLabel 
                                                          value="female" 
                                                          control={<Radio />} 
                                                          label="Female" 
                                                          />
                                                          <FormControlLabel value="male" control={<Radio />} label="Male" />
                                                          <FormControlLabel value="other" control={<Radio />} label="Other" />
                                                          <FormControlLabel value="disabled" disabled control={<Radio />} label="(Disabled option)" /> */}
    </RadioGroup>
                                                                        {/* 
                                                                                        <RadioGroup
                                                                                          {...input}
                                                                                          {...custom}

                                                                                          disabled={locked}

                                                                                          native
                                                                                                                                                                          //  displayEmpty          
                                                                                                                                                                          // fullWidth

                                                                                                                                                                          // checked={this.props.referralEntry.employedduringpasthistory.toString() === '0'}
                                                                                        >
                                                                                          {/* {children} * /}
                                                                                        </RadioGroup> */}

                                                        {/* <RadioGroup row>
                                                          {dataArray.map((optionItem) => (
                                                            <React.Fragment key={optionItem.value} >
                                                              <FormControlLabel
                                                                label={optionItem.label}
                                                                control={
                                                                  <Field
                                                                    type="radio"
                                                                    component={Radio}
                                                                    name={objName}
                                                                    value={optionItem.value}
                                                                  />
                                                                }
                                                              /> */}
                                              {/* </React.Fragment> */}
                                            {/* ))} */}
                                          {/* </RadioGroup> */}
                                          
    <FormHelperText>
      {footerMessage}
                                                {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
    </FormHelperText>
  </FormControl>
)




/*** Drop Down Selection with changing options based on conditions*/
/*** children displayed as a child object */
export const renderSelectField_Conditional_Options = ({
  id,
  objName,
  footerMessage,
  label,
  locked,
  children,
  onChangeMethod,
  requireOnChangeMethod = true,
  input: { onChange, onToggle },
  meta: { touched, error },
  ...rest
}) => (
  <FormControl fullWidth error={touched}>
    <Field
      component={Select}
      label={label}
      name={objName}
      disabled={locked}
      formControlProps={{
        fullWidth: true,
        margin: 'none'
      }}
      {...rest}>
      {children}
    </Field>
    <OnChange name={objName}>
      {(value, previous) => {
        if (requireOnChangeMethod) {
          onChangeMethod(value);
        }
      }}
    </OnChange>
    <FormHelperText>{footerMessage}</FormHelperText>
  </FormControl>
);






/*** Drop Down Selection */
/*** NOTE REQUIRES objName to set the name !!! */
/*** dataArray = [ { value: 1, label: 'label' }] */
/*** children displayed as a child object */
export const renderSelectField = ({
  requireOnChangeMethod = true,
  onChangeMethod,
  objName,
  footerMessage,
  label,
  locked,
  dataArray,
  children,
  input: { onChange, onToggle },
  meta: { touched, error },
  ...rest
}) => (
  <FormControl variant="outlined" fullWidth error={touched}>
    <Field
      component={Select}
      label={label}
      name={objName}
      disabled={locked}
      formControlProps={{
        fullWidth: true,
        margin: 'none'
      }}
      {...rest}>
      {dataArray.map((optionItem) => (
        <MenuItem key={optionItem.value} value={optionItem.value}>
          {optionItem.label}
        </MenuItem>
      ))}
    </Field>
    <OnChange name={objName}>
      {(value, previous) => {
        if (requireOnChangeMethod) {
          onChangeMethod(value);
        }
      }}
    </OnChange>

    <FormHelperText>{footerMessage}</FormHelperText>
  </FormControl>
);





// prior
/*** Drop Down Selection */
                                                /*** NOTE REQUIRES objName to set the name !!! */
                                                /*** dataArray = [ { value: 1, label: 'label' }] */
/*** children displayed as a child object */
/*** dataArray = [ { value: 1, label: 'label' }] */
export const renderSelectField2 = ({
                                    // name,
  objName,
  footerMessage,
  label,
  locked,
  dataArray,
                                          // meta: { touched, error },
  meta: { touched, error, onChange },
                                          // meta: { touched, onChange },
                                          // meta: { touched, invalid, error },
                                          // meta: { touched },
                                                                                            // id,
                                                                                            // children,
                                                                                            // displayEmpty,
                                        // input,
                                        // ...rest




                                                          //                     id,
                                                          //                     children,
                                                                    
                                                          //                     // name,
                                                          // objName,
                                                          // footerMessage,
                                                          // label,
                                                          // locked,
                                                          // dataArray,
                                                          // value,
                                                          // // meta: { touched, error },
                                                          // // meta: { touched, error, onChange },
                                                          // // meta: { touched, onChange },
                                                          // // meta: { touched, invalid, error },
                                                          // // meta: { touched },
                                                          // meta: { touched, error, onChange },
                                                          //                                                     // id,
                                                          //                                                     // children,
                                                          //                                                     // displayEmpty,
                                                          // input,
                                                          // // ...rest

                                                          
}) => (
  <FormControl
    variant="outlined"
    fullWidth 
    error={touched }
  >
                                              {/* <InputLabel id={objName + '-label'}>{label}</InputLabel> */}
    <Field
      component={Select}
                                                // labelId={objName + '-label'}
      label={label}
                                                // name={name}
      name={objName}
      disabled={locked}
      onChange={onChange}
      formControlProps={{ 
                                                // className: 'my-class',
        fullWidth: true,
        margin: 'none'
      }}
    >
      {dataArray.map((optionItem) => (
        <MenuItem key={optionItem.value} value={optionItem.value}>{optionItem.label}</MenuItem>
      ))}
    </Field>



                                                            {/* 
                                                                <Select
                                                                // <SelectField

                                                            // component={Select}


                                                            // formControlProps={{ 
                                                            //   fullWidth: true,
                                                            //   margin: 'none'
                                                            // }}
                                                            // fullWidth
                                                                                                        // displayEmpty={displayEmpty ? true : false }
                                                            // // {...input}
                                                            // // {...rest}


                                                                  labelId={objName}
                                                                  name={objName}
                                                                  // id={id}
                                                                  
                                                                  // value={value}
                                                                  // onChange={onChange}
                                                                  label={label}
                                                                  disabled={locked}
                                                                  native
                                                                  // fullWidth
                                                                        //  displayEmpty          

                                                                                          // labelId="demo-simple-select-label"
                                                                                          // id="demo-simple-select"
                                                                                          // value={age}
                                                                                          // onChange={handleChange}
                                                                    >
                                                                      {dataArray.map((optionItem) => (
                                                                        <MenuItem key={optionItem.value} value={optionItem.value}>{optionItem.label}</MenuItem>
                                                                      ))}
                                                                    </Select>

                                                                    */}
                                                                    {/* </SelectField> */}



                                                                                                  {/* 

                                                                                                          //////
                                                                                                          //   //////
                                                                                                            
                                                                                                          //   <FormControl  className={classes.formControl}>
                                                                                                          //   <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel>
                                                                                                          //   <Select
                                                                                                          //     labelId="demo-simple-select-outlined-label"
                                                                                                          //     id="demo-simple-select-outlined"
                                                                                                          //     value={age}
                                                                                                          //     onChange={handleChange}
                                                                                                          //     label="Age"
                                                                                                          //   >
                                                                                                          //     <MenuItem value="">
                                                                                                          //       <em>None</em>
                                                                                                          //     </MenuItem>
                                                                                                          //     <MenuItem value={10}>Ten</MenuItem>
                                                                                                          //     <MenuItem value={20}>Twenty</MenuItem>
                                                                                                          //     <MenuItem value={30}>Thirty</MenuItem>
                                                                                                          //   </Select>
                                                                                                          // </FormControl>

                                                                                                          //   //////
                                                                                                          //   ////// 
                                                                                                          */}


                                                                                                                      {/* 
                                                                                                                        <Field
                                                                                                                          component={Select}
                                                                                                                          name={objName}
                                                                                                                          label={label}
                                                                                                                          formControlProps={{ 
                                                                                                                            fullWidth: true,
                                                                                                                            margin: 'none'
                                                                                                                          }}
                                                                                                                          disabled={locked}
                                                                                                                          fullWidth
                                                                                                                                                                      // displayEmpty={displayEmpty ? true : false }
                                                                                                                          // // {...input}
                                                                                                                          // // {...rest}
                                                                                                                        >
                                                                                                                          {dataArray.map((optionItem) => (
                                                                                                                            <MenuItem key={optionItem.value} value={optionItem.value}>{optionItem.label}</MenuItem>
                                                                                                                          ))}
                                                                                                                                                                                                                          {/* {children} * /}
                                                                                                                        </Field> 
                                                                                                                        */}
                                                              

                                                              
  <FormHelperText>
    {footerMessage}
                                                    {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
  </FormHelperText>
</FormControl>
)

/*** SNACK BAR Custom Error*/
  export const renderSnackbarErrorCustom = ({
    input,
    error,
  }) => (
  <FormControl fullWidth >
    {(error) ?
      <SnackbarError
        variant="error"
        message = {error}
      />
    : ''}
  </FormControl>
  )

/*** SNACK BAR ERROR */
  export const renderSnackbarError = ({
    input,
    meta: { touched, invalid, error },
  ...rest
  }) => (
  <FormControl fullWidth error={touched }>
    {(error) ?
      <SnackbarError
        variant="error"
        message = {error}
      />
    : ''}
  </FormControl>
  )











///////////////////////////////////////////////////









                                                                                      // import {
                                                                                      //   // TimePicker,
                                                                                      // } from 'mui-rff';

                                                                                      // import {
                                                                                      //   DatePicker,
                                                                                      //   MuiPickersUtilsProvider,
                                                                                      //   TimePicker,
                                                                                      // } from '@material-ui/pickers';


                                                                                      // /*** Date Picker */
                                                                                      // import DateFnsUtils from '@date-io/date-fns';




                                                                    // /*** Date Text Box */
                                                                    // /*** works but not needed for this project */
                                                                    // export const renderDateTextField = ({
                                                                    //   objName,
                                                                    //   requiredText,
                                                                    //   locked,
                                                                    //   label,
                                                                    //   emptyText,
                                                                    //   footerMessage,
                                                                    //   id,
                                                                    //   rows,
                                                                    //   meta: { touched, invalid, error },
                                                                    //   input: { name, onChange, value, ...restInput },
                                                                    //   ...rest
                                                                    // }) => (
                                                                    //   <FormControl fullWidth error={touched }>
                                                                    //   <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                    //     <DatePicker
                                                                    //                     // {...rest}
                                                                    //                     // name={name}
                                                                    //                     // // helperText={showError ? meta.error || meta.submitError : undefined}
                                                                    //                     // // error={showError}
                                                                    //                     // // inputProps={restInput}
                                                                    //                     // onChange={onChange}
                                                                    //                     // value={value === '' ? null : value}


                                                                    //       // required={requiredText ? true : false }
                                                                    //       // disabled={locked}
                                                                    //       name={objName}
                                                                    //       // label={label}
                                                                    //       // placeholder={emptyText}
                                                                    //       // helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                                                                    //       // defaultValue={defaultValue}
                                                                    //       value={value}
                                                                    //                                                       // error={touched && invalid} // remove 
                                                                    //       // error={error ? true : false}
                                                                    //       // hinttext={footerMessage}                                      
                                                                    //       // fullWidth
                                                                    //       // variant='outlined'
                                                                    //                                                       // {...input}
                                                                    //       {...rest}

                                                                                                                          
                                                                    //     />
                                                                    //   </MuiPickersUtilsProvider>
                                                                    //   <FormHelperText>
                                                                    //     {footerMessage}
                                                                    //     {(error) ? <span><b> <br /> {error} </b></span>: ''}
                                                                    //  </FormHelperText>
                                                                    // </FormControl>
                                                                    // )



                                                                                // /*** Checkbox Group */
                                                                                // export const renderCheckboxGroup = ({
                                                                                //   label,
                                                                                //   locked,
                                                                                //   checked,
                                                                                //   footerMessage,
                                                                                //   dataArray,
                                                                                //   meta: { touched, invalid, error },
                                                                                //   ...rest
                                                                                // }) => (
                                                                                // <FormControl fullWidth error={touched }>
                                                                                //   <Checkboxes
                                                                                //     formControlProps={{ margin: 'none' }}
                                                                                //     label={label}
                                                                                //     data={{ 
                                                                                //       label: label,
                                                                                //       value: checked,
                                                                                //       disabled: locked,
                                                                                //     }}
                                                                                //     {...rest}
                                                                                //   />
                                                                                //     <Checkboxes
                                                                                //       name="sauces"
                                                                                //       label={label}
                                                                                //       formControlProps={{ margin: 'none' }}
                                                                                //       formGroupProps={{ row: true }}
                                                                                //       data={dataArray}
                                                                                //     />
                                                                                //   <FormHelperText>
                                                                                //     {footerMessage}
                                                                                //     {(error) ? <span><b> <br /> {error} </b></span>: ''}
                                                                                //                                                         {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                                //   </FormHelperText>
                                                                                // </FormControl>
                                                                                // )








                                                                            // /*** Multi Select List Group */
                                                                            // /*** NOTE REQUIRES objName to set the name !!! */
                                                                            // /*** dataArray = [ { value: 1, label: 'label' }] */
                                                                            // export const renderMultiSelectList = ({
                                                                            //   objName,
                                                                            //   label,
                                                                            //   locked,
                                                                            //   checked,
                                                                            //   footerMessage,
                                                                            //   dataArray,
                                                                            //   meta: { touched, invalid, error },
                                                                            //   ...rest
                                                                            // }) => (
                                                                            // <FormControl fullWidth error={touched }>
                                                                            //   <Field 
                                                                            //     component="select"
                                                                            //     multiple
                                                                            //     name={objName} 
                                                                            //   >
                                                                            //     {dataArray.map((optionItem) => (
                                                                            //       <option value={optionItem.value}>{optionItem.label}</option>
                                                                            //     ))}

                                                                            //                                                                           {/* 
                                                                            //                                                                             <option value="mushrooms">🍄 Mushrooms</option>
                                                                            //                                                                             <option value="cheese">🧀 Cheese</option>
                                                                            //                                                                             <option value="chicken">🐓 Chicken</option>
                                                                            //                                                                             <option value="pineapple">🍍 Pinapple</option> 
                                                                            //                                                                           */}

                                                                            //   </Field>
                                                                            //   <FormHelperText>
                                                                            //     {footerMessage}
                                                                            //     {(error) ? <span><b> <br /> {error} </b></span>: ''}
                                                                            //                                                                           {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                            //   </FormHelperText>
                                                                            // </FormControl>
                                                                            // )







